var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h1',{staticClass:"db-title"},[_vm._v("👋 "+_vm._s(_vm.message)+", "+_vm._s(_vm.name)+"!")])}
var staticRenderFns = []

export { render, staticRenderFns }